import { useMutation } from '@tanstack/react-query'
import { applyCoupon } from '@api/applyCoupon'
import type { ApplyCouponPayload, ApplyCouponResponse } from '@api/applyCoupon'

export const useApplyCoupon = () =>
  useMutation<ApplyCouponResponse, Error, ApplyCouponPayload>({
    mutationFn: applyCoupon,
  })

